import { useTranslation } from "react-i18next";
import { UserAvatarWithName } from "@/components/common/UserAvatarWithName";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { UserShort } from "@/lib/humhub-api/types";

interface SendNowDialogProps {
  open: boolean;
  participants: UserShort[];
  isSubmitting: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const SendNowDialog = ({
  open,
  participants,
  isSubmitting,
  onOpenChange,
  onConfirm,
}: SendNowDialogProps) => {
  const { t } = useTranslation();
  const participantList = participants ?? [];

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!isSubmitting) {
          onOpenChange(next);
        }
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t("eventManage.reminderEmailSendNowConfirmTitle")}
          </DialogTitle>
          <DialogDescription>
            {t("eventManage.reminderEmailSendNowConfirmDescription")}
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-60 overflow-y-auto rounded-md border p-3">
          {participantList.length > 0 ? (
            <ul className="space-y-2">
              {participantList.map((participant) => (
                <li key={participant.id}>
                  <UserAvatarWithName user={participant} size="md" showName />
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-sm text-gray-500">
              {t("eventManage.reminderEmailNoParticipants")}
            </p>
          )}
        </div>
        <div className="flex justify-end gap-2 pt-4">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            {t("common.cancel")}
          </Button>
          <Button
            variant="teal"
            onClick={onConfirm}
            disabled={isSubmitting || participantList.length === 0}
          >
            {t("eventManage.reminderEmailSendNowConfirmButton", {
              count: participantList.length,
            })}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
